import React from 'react';
import {Badge} from '..';
import {ActiveLink, ActivePill, ActivePillText} from './styles';

export default ({
  title,
  path,
  wBadge,
  numBadge,
  active,
  onClick,
}: {
  title: string;
  path?: string;
  wBadge?: boolean;
  numBadge?: number;
  active?: boolean;
  onClick?: any;
}) => (
  <>
    {wBadge ? (
      <ActivePill active={active} onClick={onClick}>
        <ActivePillText>{title}</ActivePillText>
        <Badge color={Boolean(numBadge) ? '#0086FF' : '#CBCFDD'} text={numBadge?.toString()} size="20px" />
      </ActivePill>
    ) : (
      <ActiveLink
        to={path || ''}
        activeStyle={{
          color: '#FFF',
          backgroundColor: 'var(--PrimaryBlue)',
        }}
        onClick={onClick && onClick}
      >
        {title}
      </ActiveLink>
    )}
  </>
);
